<form [formGroup]="form" (ngSubmit)="ciudad ? update() : create()" appPermissionControl="P260F0001">
    <div class="form-row mt-3">
        <div class="form-field">
            <input pInputText type="text" formControlName="claveZona" class="form-control" [placeholder]="'Clave zona'" disabled appPermissionControl="P260K0001">
            <label>Clave Zona</label>
        </div>
    </div>
    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="claveCd" class="form-control" [placeholder]="'Ingrese clave ciudad'" [disabled]="ciudad" appPermissionControl="P260K0002">
            <label>Clave Ciudad</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="ciu_mun_del" class="form-control" [placeholder]="'Ingrese nombre ciudad'" appPermissionControl="P260K0003">
            <label>Nombre Ciudad</label>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" (click)="ciudad ? update() : create()" [disabled]="!form.valid || loading" appPermissionControl="P260B0001">
            <mat-icon>save</mat-icon>
            {{ ciudad ? 'Actualizar' : 'Guardar' }}
        </button>
        <button *ngIf="ciudad" mat-flat-button class="btn-search btn-menu" type="button" (click)="openCustomizables()" appPermissionControl="P260B0002">
            <mat-icon>tune</mat-icon>
            Customizables
        </button>
    </div>
</form>

<style>
    :host ::ng-deep .form-row {
        display: flex;
        flex-direction: row;
        margin-bottom: 1rem;
    }

    :host ::ng-deep .form-field {
        flex: 1;
        display: flex;
        flex-direction: column-reverse;
        position: relative;
    }

    :host ::ng-deep .form-control {
        width: 100%;
        padding: 0.5rem;
        font-size: 1rem;
        border: 1px solid #ced4da;
        border-radius: 4px;
        background: #fff;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    :host ::ng-deep .form-control:disabled {
        background: #e0e0e0 !important;
        color: #555 !important;
        opacity: 1 !important;
    }

    :host ::ng-deep .form-field label {
        font-size: 0.85rem;
        color: #6c757d;
        margin-bottom: 0.25rem;
    }

    :host ::ng-deep .button-section {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
        margin-top: 1.5rem;
    }
</style> 